import Request from 'redux/config/services/Request'
import { ConciergeWebSocketUrl } from 'redux/config/services/Constants'
import { getPlatformType } from 'shared/Router/Utils'

export const conciergeBasePath = (): string =>
  getPlatformType() === 'employee'
    ? '/ai_concierge/employee'
    : '/ai_concierge/admin'

export const openChatRoom = async (): Promise<object> => {
  const response = await Request.post(`${conciergeBasePath()}/chatrooms/`, {})
  return response
}

export const getChats = async (
  chatRoomId: string,
  threadId: string,
  noOfChats: number = 200
): Promise<object> => {
  const response = await Request.get(
    `${conciergeBasePath()}/chatrooms/${chatRoomId}/${threadId}/chats/?num_chats=${noOfChats}`
  )
  return response
}

export const postChatToDb = async (
  chatId: string,
  chatRoomId: string,
  message: string,
  threadId: string
): Promise<object> => {
  const response = await Request.post(
    `${conciergeBasePath()}/chatrooms/${chatRoomId}/${threadId}/chats/`,
    {
      message,
      id: chatId,
      threadId,
    }
  )
  return response
}

export const fetchConciergeWsTicket = async (
  chatRoomId: string
): Promise<string> => {
  const response = await Request.post(`${conciergeBasePath()}/ws-ticket/`, {
    chatroom_id: chatRoomId,
  })
  return response.data.ticket
}

export const openRealtimeWebSocket = async (
  chatRoomId: string
): Promise<WebSocket> => {
  const ticket = await fetchConciergeWsTicket(chatRoomId)
  const url = ConciergeWebSocketUrl(
    `/ws/chatroom/${chatRoomId}?ticket=${encodeURIComponent(ticket)}`
  )
  return new Promise((resolve, reject) => {
    const ws = new WebSocket(url)
    ws.onopen = () => resolve(ws)
    ws.onerror = (error) => reject(error)
  })
}

export const closeWebSocket = async (websocket: WebSocket): Promise<void> => {
  websocket.close()
}

export const deleteChatRoom = async (): Promise<object> => {
  const response = await Request.post(`${conciergeBasePath()}/chatrooms/`, {
    delete: true,
  })
  return response
}
